import { useEffect, useState } from "react";
import { Alert, Checkbox, Field, Stack } from "@leylion/design-system";
import { getCouponPrint, searchCouponProducts } from "../api/client";
import type { CouponProduct } from "../api/crm-types";
import { valueError } from "../shared/value-copy";

export function CouponProducts({ couponId, value, onChange, language, disabled }: {
  couponId?: string; value: string[]; onChange: (ids: string[]) => void; language: "ar" | "en"; disabled: boolean;
}) {
  const ar = language === "ar";
  const [search, setSearch] = useState(""); const [results, setResults] = useState<CouponProduct[]>([]);
  const [known, setKnown] = useState<Record<string, CouponProduct>>({}); const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    if (couponId) void getCouponPrint(couponId).then(data => { if (active) setKnown(old => ({ ...old, ...Object.fromEntries(data.products.map(p => [p.id, p])) })); })
      .catch(e => { if (active) setError(valueError(e, language)); });
    return () => { active = false; };
  }, [couponId, language]);
  useEffect(() => {
    let active = true;
    if (disabled) return;
    const timer = window.setTimeout(() => { void searchCouponProducts(search).then(items => {
      if (!active) return; setResults(items); setKnown(old => ({ ...old, ...Object.fromEntries(items.map(p => [p.id, p])) })); setError("");
    }).catch(e => { if (active) setError(valueError(e, language)); }); }, 250);
    return () => { active = false; window.clearTimeout(timer); };
  }, [search, disabled, language]);
  const ids = [...new Set([...value, ...results.map(p => p.id)])];
  return <Stack>
    <Field data-testid="coupon-product-search" label={ar ? "بحث الأصناف" : "Search products"} value={search} maxLength={100} disabled={disabled} onChange={e => setSearch(e.target.value)} />
    <small>{ar ? `الأصناف المحددة: ${value.length} / 100. ابحث للوصول إلى أصناف أخرى.` : `Selected products: ${value.length} / 100. Search to find other products.`}</small>
    {error ? <Alert tone="danger" title={ar ? "تعذر تحميل الأصناف" : "Products could not be loaded"}>{error}</Alert> : null}
    <div style={{ maxHeight: 260, overflowY: "auto" }}>
      {ids.map(id => <Checkbox key={id} data-testid={`coupon-product-${id}`} label={known[id] ? (ar ? known[id].nameAr : known[id].nameEn) : id}
        checked={value.includes(id)} disabled={disabled || (!value.includes(id) && value.length >= 100)}
        onChange={e => onChange(e.target.checked ? [...value, id] : value.filter(x => x !== id))} />)}
    </div>
  </Stack>;
}
